export function createPresenceClient() {
  const listeners = new Map();
  let ws = null;
  let backoff = 1000;
  let manualClose = false;

  function on(event, fn) {
    if (!listeners.has(event)) listeners.set(event, new Set());
    listeners.get(event).add(fn);
    return () => listeners.get(event).delete(fn);
  }
  function emit(event, payload) {
    const set = listeners.get(event);
    if (set) for (const fn of set) try { fn(payload); } catch (e) { console.error(e); }
  }

  function connect() {
    const proto = location.protocol === "https:" ? "wss:" : "ws:";
    ws = new WebSocket(`${proto}//${location.host}/api/presence`);
    ws.addEventListener("open",  () => { backoff = 1000; });
    ws.addEventListener("close", () => {
      emit("disconnect");
      if (manualClose) return;
      setTimeout(connect, backoff);
      backoff = Math.min(backoff * 2, 30_000);
    });
    ws.addEventListener("error", () => { /* close will follow */ });
    ws.addEventListener("message", (e) => {
      let msg; try { msg = JSON.parse(e.data); } catch { return; }
      if (msg && typeof msg.type === "string") emit(msg.type, msg);
    });
  }

  function send(msg) {
    if (ws && ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify(msg));
  }
  function close() { manualClose = true; if (ws) ws.close(); }

  return { connect, send, close, on };
}
